/**
 * Constants for the table-ui package
 */

/** Height of the global header that affects sticky positioning */
export const GLOBAL_HEADER_HEIGHT = 64;

/**
 * Approximate height of the mobile View-as pill when it sits in page content
 * below the header (`md` and down). Desktop/tablet View-as is inline in the
 * 64px header, so this offset is unused there.
 */
export const VIEW_AS_MOBILE_BANNER_HEIGHT = 60;

/** Height of the banner skeleton loader when in loading state */
export const BANNER_SKELETON_HEIGHT = 64;

/** Sentinel value to indicate uninitialized banner position */
export const UNINITIALIZED_POSITION = -1;

/**
 * CSS custom property set on the table root when the selection banner is
 * viewport-pinned on a page-scroll table. Sticky header cells (`th`) read this
 * so they sit below the global header + banner. Contained-scroll tables clear
 * this var — headers stick inside the table scrollport, outside the banner.
 */
export const TABLE_STICKY_HEADER_TOP_VAR = '--table-sticky-header-top';
